import Vue from "vue";
import Router from "vue-router";
import Novedades from "../components/Novedades";
import BaseFuturo from "../components/BaseFuturo";
import BaseAssa from "../components/BaseAssa";
import Roles from "../components/Rol";
import Usuarios from "../components/Usuario";
import Cabina from "../components/Cabina";
import Login from "../components/Login";
import Bitacora from "../components/Bitacora";
import Plantilla from "../components/Plantilla";
import Reincidencia from "../components/Reincidencia";
import Guardia from "../components/Guardia";
import Informe from "../components/Informe";
import SumaCostos from "../components/SumaCostos";
import Historico from "../components/Historico";
import Graficos from "../components/Graficos";
import VerificarFuturo from "../components/VerificarFuturo";
import SolicitudesAR from "../components/SolicitudesAR";
import Evaluacion from "../components/Evaluacion";
import PagosProveedor from "../components/PagosProveedor";
import MapaProveedores from "../components/MapaProveedores";
import store from "../store";
import DiseñoProveedores from "../components/DiseñoProveedores";
import ServiciosInternacionales from "../components/ServiciosInternacionales";
import Bauchers from "../components/FormBaucher";
import AsistenciaProveedor from "../components/AsistenciaProveedor";
import ImagenesProvider from "../components/ImagenesProvider";
import BitacoraProvider from "../components/BitacoraProvider";
import AsistenciasApp from "../components/AppMovilAsistencias";
import HistorialAsistenciasApp from "../components/AppMovilHistorial";
import ProveedoresApp from "../components/AppMovilProveedores";
import ReembolsoAppMovil from "../components/AppMovilReembolsos";
import Quedan from "../components/Quedan";
import Coordenadas from "../components/Coordenadas";
import Facturas from "../components/FormFactura";
import Legales from "../components/Legal";
import SolicitudGrabacion from "../components/SolicitudGrabacion";
import SolicitudInformacion from "../components/SolicitudInformacion";
import UsuariosWeb from "../components/UsuariosWeb";
import BaseProveedoresBaucher from "../components/BaseProveedoresBaucher";
import BaseClientesFactura from "../components/BaseClienteFactura";
import FormReciboRenta from "../components/FormReciboRenta";
import GuardiaV1 from "../components/GuardiaV1";
import Modulos from "../components/Modulos";
import ComsumidorFinal from "../components/FormConsumidorFinal";
import SujetoExcluido from "../components/FormSujetoExcluido";
import AdminArchivos from "../view/AdminArchivos";
import AuthGoogleDrive from "../view/AuthGoogleDrive";
import PartePolicial from "../components/PartePolicial";
import Compartido from "../components/Intranet/Compartido";
import Noticias from "../components/Intranet/Noticias";
import WhatsApp from "../components/WhatsAppApi/WhatsApp";
import PlantillasWaApi from "../components/WhatsAppApi/PlantillasWaApi";
import Carteras from "../components/Catalogos/Carteras";
import BaseSisa from "../components/Bases/BaseSisa";
import OperadoresGrua from "../components/Catalogos/OperadoresGrua";
import AsignarGrua from "../components/AsignarGrua.vue";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "novedades",
      component: Novedades,
      meta: {
        administrador: true,
        usuario: true,
        inspector: true,
      },
    },
    {
      path: "/operadoresGrua",
      name: "operadoresGrua",
      component: OperadoresGrua,
      meta: {
        administrador: true,
      },
    },
    {
      path: "/Boleta/:numAsistencia",
      name: "FormularioFirma",
      meta: {
        noPadding: true,
      },
      component: () => import("../components/FormularioFirma.vue"),
    },
    {
      path: "/Sisa/Encuesta/:asistencia",
      name: "EncuestaSisa",
      meta: {
        noPadding: true,
      },
      component: () => import("../components/EncuestaSISA.vue"),
    },
    {
      path: "/Sisa/HistorialEncuestas",
      name: "HistorialEncuestas",
      component: () => import("../components/HistorialEncuestasSISA.vue"),
    },
    {
      path: "/Marcaciones/Historial",
      name: "HistorialMarcaciones",
      component: () =>
        import("../components/Marcaciones/HistorialMarcaciones.vue"),
    },
    {
      path: "/Marcaciones/Departamentos",
      name: "DepartamentosMarcaciones",
      component: () =>
        import("../components/Marcaciones/DepartamentosMarcaciones.vue"),
    },
    {
      path: "/Marcaciones/Posiciones",
      name: "PosicionesMarcaciones",
      component: () =>
        import("../components/Marcaciones/PosicionesMarcaciones.vue"),
    },
    {
      path: "/Marcaciones/Empleados",
      name: "EmpleadosMarcaciones",
      component: () =>
        import("../components/Marcaciones/EmpleadosMarcaciones.vue"),
    },
    {
      path: "/Sisa/HistorialReenvios",
      name: "HistorialReenvioEncuestas",
      component: () => import("../components/HistorialReenvioEncuestas.vue"),
    },
    {
      path: "/Horario",
      name: "Horario",
      component: () =>
        import("../components/Marcaciones/Horarios/Horarios.vue"),
    },
    {
      path: "/Horario/:id",
      name: "MiniHorario",
      component: () => import("../components/Minis/MiniHorarios.vue"),
    },
    {
      path: "/HorariosEmpleados",
      name: "HorariosEmpleados",
      component: () =>
        import("../components/Marcaciones/Horarios/HorariosEmpleados.vue"),
    },
    {
      path: "/Preguntas",
      name: "Preguntas",
      component: () => import("../components/Preguntas.vue"),
    },
    {
      path: "/baseSisa",
      name: "baseSisa",
      component: BaseSisa,
      meta: {
        administrador: true,
      },
    },
    {
      path: "/carteras",
      name: "carteras",
      component: Carteras,
      meta: {
        administrador: true,
      },
    },
    {
      path: "/Extensiones",
      name: "Extensiones",
      component: () => import("../components/Catalogos/Extensiones.vue"),
    },
    {
      path: "/AuditLogs",
      name: "AuditLogs",
      component: () => import("../components/AuditLogs.vue"),
    },
    {
      path: "/TipoAsistencias",
      name: "TipoAsistencias",
      component: () => import("../components/Catalogos/TipoAsistencias.vue"),
    },
    {
      path: "/CostosProveedores/:id",
      name: "CostosProveedores",
      component: () => import("../components/CostosProveedores.vue"),
    },
    {
      path: "/Equipos",
      name: "Equipos",
      component: () => import("../components/Catalogos/Equipos.vue"),
    },
    {
      path: "/HistorialOperadoresGrua",
      name: "HistorialOperadoresGrua",
      component: () => import("../components/LogOperadoresGrua.vue"),
      meta: {
        administrador: true,
      },
    },
    {
      path: "/HistorialGuardia",
      name: "HistorialGuardia",
      component: () => import("../components/HistorialGuardia.vue"),
    },
    {
      path: "/ServicioConexion/:asistencia",
      name: "ServicioConexion",
      component: () => import("../components/ServiciosConexion.vue"),
    },
    {
      path: "/HistorialServiciosConexion",
      name: "HistorialServiciosConexion",
      component: () => import("../components/HistorialServiciosConexion.vue"),
    },
    {
      path: "/HistorialOperadoresCabina",
      name: "HistorialOperadoresCabina",
      component: () => import("../components/LogOperadoresCabina.vue"),
      meta: {
        administrador: true,
      },
    },
    {
      path: "/HistorialInspectores",
      name: "HistorialInspectores",
      component: () => import("../components/LogInspectores.vue"),
      meta: {
        administrador: true,
      },
    },
    {
      path: "/AsignarGrua",
      name: "AsignarGrua",
      component: AsignarGrua,
      meta: {
        administrador: true,
        operadorGrua: true,
      },
    },
    {
      path: "/AsignarExtensionCabina",
      name: "AsignarExtensionCabina",
      component: () => import("../components/AsignarExtensionCabina.vue"),
    },
    {
      path: "/ProveedoresAsignados",
      name: "proveedoresAsignados",
      component: () => import("../components/ProveedoresAsignados.vue"),
    },
    {
      path: "/SLASisa",
      name: "SLASisa",
      component: () => import("../components/SLAs/InformeSISA.vue"),
    },
    {
      path: "/whatsApp",
      name: "whatsApp",
      component: WhatsApp,
      meta: {
        administrador: true,
      },
    },
    // {
    //   path: "/ContactosWA",
    //   name: "contactoWA",
    //   component: () => import("../components/ContactosWhatsApp.vue"),
    // },
    {
      path: "/UsuariosCartera",
      name: "usuariosCartera",
      component: () => import("../components/UsuariosPorCartera.vue"),
    },
    {
      path: "/ContactosWA/:telefono?",
      name: "contactoWA",
      component: () => import("../components/ContactosWhatsApp.vue"),
    },
    {
      path: "/plantillasWaApi",
      name: "plantillasWaApi",
      component: PlantillasWaApi,
      meta: {
        administrador: true,
      },
    },
    {
      path: "/compartido",
      name: "compartido",
      component: Compartido,
      meta: {
        administrador: true,
      },
    },
    {
      path: "/noticias",
      name: "noticias",
      component: Noticias,
      meta: {
        administrador: true,
      },
    },
    {
      path: "/partePolicial",
      name: "partePolicial",
      component: PartePolicial,
      meta: {
        administrador: true,
      },
    },
    {
      path: "/adminArchivos/:id",
      name: "adminArchivos",
      component: AdminArchivos,
      meta: {
        administrador: true,
      },
    },
    {
      path: "/adminArchivosConexion/:id",
      name: "adminArchivosConexion",
      component: () =>
        import("../components/AdminArchivosServiciosConexion.vue"),
    },
    {
      path: "/authGoogleDrive",
      name: "authGoogleDrive",
      component: AuthGoogleDrive,
      meta: {
        administrador: true,
      },
    },
    {
      path: "/sujetoExcluido",
      name: "sujetoExcluido",
      component: SujetoExcluido,
      meta: {
        administrador: true,
      },
    },
    {
      path: "/consumidorFinal",
      name: "consumidorFinal",
      component: ComsumidorFinal,
      meta: {
        administrador: true,
      },
    },
    {
      path: "/modulos",
      name: "modulos",
      component: Modulos,
      meta: {
        administrador: true,
      },
    },
    {
      path: "/guardiaV1",
      name: "guardiav1",
      component: GuardiaV1,
      meta: {
        administrador: true,
        usuario: true,
        inspector: true,
      },
    },
    {
      path: "/graficos",
      name: "graficos",
      component: Graficos,
      meta: {
        administrador: true,
      },
    },
    {
      path: "/baseFuturo",
      name: "baseFuturo",
      component: BaseFuturo,
      meta: {
        administrador: true,
      },
    },
    {
      path: "/baseAssa",
      name: "baseAssa",
      component: BaseAssa,
      meta: {
        administrador: true,
      },
    },
    {
      path: "/cabina",
      name: "cabina",
      component: Cabina,
      meta: {
        administrador: true,
        usuario: true,
        inspector: true,
      },
    },
    {
      path: "/bitacora",
      name: "bitacora",
      component: Bitacora,
      meta: {
        administrador: true,
        usuario: true,
      },
    },
    {
      path: "/verificarFuturo",
      name: "verificarFuturo",
      component: VerificarFuturo,
      meta: {
        administrador: true,
        usuario: true,
      },
    },
    {
      path: "/plantilla",
      name: "plantilla",
      component: Plantilla,
      meta: {
        administrador: true,
        usuario: true,
      },
    },
    {
      path: "/reincidencia",
      name: "reincidencia",
      component: Reincidencia,
      meta: {
        administrador: true,
        usuario: true,
      },
    },
    {
      path: "/roles",
      name: "roles",
      component: Roles,
      meta: {
        administrador: true,
      },
    },
    {
      path: "/guardia",
      name: "guardia",
      component: Guardia,
      meta: {
        administrador: true,
        usuario: true,
        inspector: true,
      },
    },
    {
      path: "/historico",
      name: "historico",
      component: Historico,
      meta: {
        administrador: true,
        usuario: true,
        inspector: true,
      },
    },
    {
      path: "/Corredor",
      name: "CorredorHistorico",
      component: () => import("../components/CorredoresHistorico.vue"),
      meta: {
        roles: ["Corredores"],
      },
    },
    {
      path: "/informe",
      name: "informe",
      component: Informe,
      meta: {
        administrador: true,
      },
    },
    {
      path: "/sumaCostos",
      name: "sumaCostos",
      component: SumaCostos,
      meta: {
        administrador: true,
      },
    },
    {
      path: "/usuarios",
      name: "usuarios",
      component: Usuarios,
      meta: {
        administrador: true,
      },
    },
    {
      path: "/solicitudesAR",
      name: "solicitudesAR",
      component: SolicitudesAR,
      meta: {
        administrador: true,
      },
    },
    {
      path: "/evaluacion",
      name: "evaluacion",
      component: Evaluacion,
      meta: {
        administrador: true,
      },
    },
    {
      path: "/pagosProveedor",
      name: "pagosProveedor",
      component: PagosProveedor,
      meta: {
        administrador: true,
      },
    },
    {
      path: "/mapaProveedores",
      name: "mapaProveedores",
      component: MapaProveedores,
      meta: {
        administrador: true,
        usuario: true,
      },
    },
    {
      path: "/diseñoProveedores",
      name: "diseñoProveedores",
      component: DiseñoProveedores,
      meta: {
        administrador: true,
      },
    },
    {
      path: "/internacionales",
      name: "internacionales",
      component: ServiciosInternacionales,
      meta: {
        administrador: true,
      },
    },
    {
      path: "/asistenciasApp",
      name: "asistenciasApp",
      component: AsistenciasApp,
      meta: {
        administrador: true,
        usuario: true,
      },
    },
    {
      path: "/bauchers",
      name: "bauchers",
      component: Bauchers,
      meta: {
        administrador: true,
      },
    },
    {
      path: "/asistenciaProveedor",
      name: "asistenciaProveedor",
      component: AsistenciaProveedor,
      meta: {
        administrador: true,
        usuario: true,
        inspector: true,
      },
    },
    {
      path: "/imagenesProvider",
      name: "imagenesProvider",
      component: ImagenesProvider,
      meta: {
        administrador: true,
        usuario: true,
      },
    },
    {
      path: "/bitacoraProvider",
      name: "bitacoraProvider",
      component: BitacoraProvider,
      meta: {
        administrador: true,
      },
    },
    {
      path: "/historialApp",
      name: "historialApp",
      component: HistorialAsistenciasApp,
      meta: {
        administrador: true,
        usuario: true,
      },
    },
    {
      path: "/reembolsoApp",
      name: "reembolsoApp",
      component: ReembolsoAppMovil,
      meta: {
        administrador: true,
      },
    },
    {
      path: "/proveedoresApp",
      name: "proveedoresApp",
      component: ProveedoresApp,
      meta: {
        administrador: true,
        usuario: true,
      },
    },
    {
      path: "/quedan",
      name: "quedan",
      component: Quedan,
      meta: {
        administrador: true,
        usuario: true,
      },
    },
    {
      path: "/coordenadas",
      name: "coordenadas",
      component: Coordenadas,
      meta: {
        administrador: true,
        usuario: true,
      },
    },
    {
      path: "/facturas",
      name: "facturas",
      component: Facturas,
      meta: {
        administrador: true,
      },
    },
    {
      path: "/legales",
      name: "legales",
      component: Legales,
      meta: {
        administrador: true,
        usuario: true,
      },
    },
    {
      path: "/SolicitudGrabacion",
      name: "solicitudGrabacion",
      component: SolicitudGrabacion,
      meta: {
        administrador: true,
      },
    },
    {
      path: "/SolicitudInformacion",
      name: "solicitudInformacion",
      component: SolicitudInformacion,
      meta: {
        administrador: true,
      },
    },
    {
      path: "/UsuariosWeb",
      name: "usuariosWeb",
      component: UsuariosWeb,
      meta: {
        administrador: true,
      },
    },
    {
      path: "/BaseProveedoresBaucher",
      name: "baseProveedoresbaucher",
      component: BaseProveedoresBaucher,
      meta: {
        administrador: true,
      },
    },
    {
      path: "/BaseClientesFactura",
      name: "baseClientesFactura",
      component: BaseClientesFactura,
      meta: {
        administrador: true,
      },
    },
    {
      path: "/FormReciboRenta",
      name: "reciboRenta",
      component: FormReciboRenta,
      meta: {
        administrador: true,
      },
    },
    {
      path: "/login",
      name: "login",
      component: Login,
      meta: {
        libre: true,
      },
    },
    {
      path: "/CambiarContraseña",
      name: "cambiarContraseña",
      component: () => import("../components/ChangePassword.vue"),
    },
  ],
});

router.beforeEach(async (to, from, next) => {
  store.commit("setTargetRoute", to.path);
  if (to.path === "/login" || to.path === "/AsignarGrua") {
    return next();
  }

  // --> ANONYMOUS ROUTES
  const formularioFirmaMatch = to.path.match(/^\/Boleta\/(\d+)$/);
  const encuestaMatch = to.path.match(/^\/Sisa\/Encuesta\/(\d+)$/);
  const servicioConexion = to.path.match(/^\/ServicioConexion\/(\d+)$/);
  if (formularioFirmaMatch || encuestaMatch || servicioConexion) {
    return next();
  }

  await store.dispatch("autoLogin");

  const user = store.getters.getUsuario;

  // =============================
  // VALIDACIÓN DE ROL CORREDOR
  // =============================

  if (!user) {
    return next("/login");
  }

  const rolNombre = user.rol;
  if (rolNombre === "Corredores") {
    const allowedRoutes = [
      "/login",
      "/Corredor",
      /^\/adminArchivos\/\d+$/, // regex para ids dinámicos
    ];

    const isAllowed = allowedRoutes.some((r) =>
      typeof r === "string" ? r === to.path : r.test(to.path)
    );

    if (!isAllowed) {
      return next("/Corredor");
    }
  }

  if (to.path != "/CambiarContraseña") {
    const UpdatePassword = store.getters.getHasNotChangePassword;
    if (UpdatePassword || UpdatePassword == null) {
      return next("/CambiarContraseña");
    }
  }

  next();
});

export default router;
